import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { EmergencyButton } from './EmergencyControls';
import { useApprovals } from './ApprovalProvider';
import './Header.css';
import WhatsAppBadge from './WhatsAppBadge';

const Header = () => {
    const { isLoggedIn, user, logout, viewingAsSales, setViewAsSales } = useAuth();
    const location = useLocation();
    // Switching views reloads the app on the dashboard, so every screen fetches its data again as the chosen role (a
    // screen already open would keep the other role's numbers).
    const switchView = (on) => { setViewAsSales(on); window.location.assign('/dashboard'); };
    const { summary } = useApprovals();

    // Admins: requests waiting for them. Sales: their requests that were denied lately (needs attention), else those still waiting.
    const bellDenied = user?.role !== 'admin' && summary.denied > 0;
    const bellCount = bellDenied ? summary.denied : summary.pending;

    if (location.pathname.endsWith('/print')) {
        return null;
    }

    return (
        <>
        <header className="header">
            <div className="logo-container">
                <img src="/logo.png" alt="Intmed Logo" className="logo" />
            </div>

            {isLoggedIn && (
                <nav className="header-nav">
                    <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>Dashboard</NavLink>
                    <NavLink to="/clients" className={({ isActive }) => isActive ? 'active' : ''}>Clientes</NavLink>
                    <NavLink to="/products" className={({ isActive }) => isActive ? 'active' : ''}>Productos</NavLink>
                    <NavLink to="/rentals" className={({ isActive }) => isActive ? 'active' : ''}>Alquileres</NavLink>
                    {user.role === 'admin' && (
                        <NavLink to="/expenses" className={({ isActive }) => isActive ? 'active' : ''}>Gastos</NavLink>
                    )}
                    <NavLink to="/quotes" className={({ isActive }) => isActive ? 'active' : ''}>Cotizaciones</NavLink>
                    <NavLink to="/conduces" className={({ isActive }) => isActive ? 'active' : ''}>Conduces</NavLink>
                    <NavLink to="/invoices" className={({ isActive }) => isActive ? 'active' : ''}>Facturas</NavLink>
                    <NavLink to="/ingresos" className={({ isActive }) => isActive ? 'active' : ''}>Ingresos</NavLink>
                    <NavLink to="/reports" className={({ isActive }) => isActive ? 'active' : ''}>Reportes</NavLink>
                    {user.role === 'admin' && (
                        <NavLink to="/admin" className={({ isActive }) => isActive ? 'active' : ''}>Admin</NavLink>
                    )}
                </nav>
            )}

            {isLoggedIn && (
                <div className="user-controls">
                    <p className="user-greeting">Hola, {user.username}</p>
                    {user.role === 'admin' && <EmergencyButton />}
                    {user.realRole === 'admin' && (
                        <button className={`btn btn-sm ${viewingAsSales ? 'btn-info' : 'btn-outline-secondary'}`}
                            title={viewingAsSales ? 'Volver a la vista de administrador' : 'Ver la aplicación como la ve un vendedor'}
                            aria-label={viewingAsSales ? 'Volver a la vista de administrador' : 'Vista de ventas'}
                            onClick={() => switchView(!viewingAsSales)}>
                            <i className={`bi ${viewingAsSales ? 'bi-eye-slash' : 'bi-person-badge'}`} />
                            <span className="view-as-text ms-1">{viewingAsSales ? 'Salir de vista de ventas' : 'Vista de ventas'}</span>
                        </button>
                    )}
                    <NavLink to="/aprobaciones" className={({ isActive }) => `btn btn-outline-secondary btn-sm approvals-bell${isActive ? ' active' : ''}`}
                        title={user.role === 'admin' ? 'Aprobaciones pendientes' : 'Mis solicitudes de aprobación'} aria-label="Aprobaciones">
                        <i className="bi bi-bell" />
                        {bellCount > 0 && <span className={`approvals-badge${bellDenied ? ' denied' : ''}`}>{bellCount > 99 ? '99+' : bellCount}</span>}
                    </NavLink>
                    <WhatsAppBadge />
                    <NavLink to="/change-password" className="btn btn-outline-secondary btn-sm" title="Cambiar mi contraseña">
                        <i className="bi bi-key" />
                    </NavLink>
                    <button className="btn btn-outline-secondary" onClick={logout} title="Cerrar sesión" aria-label="Cerrar sesión">
                        <span className="logout-text">Cerrar sesión</span>
                        <i className="bi bi-box-arrow-right logout-icon" />
                    </button>
                </div>
            )}
        </header>
        {viewingAsSales && (
            <div className="view-as-banner no-print">
                <i className="bi bi-person-badge me-2" />
                Estás viendo la aplicación como un <strong className="mx-1">vendedor</strong>: tus números, sin Gastos ni Admin, y lo que hagas pide aprobación como lo pediría un vendedor.
                <button className="btn btn-sm btn-outline-secondary ms-3" onClick={() => switchView(false)}>Volver a vista de administrador</button>
            </div>
        )}
        </>
    );
};

export default Header;
